import { NgClass } from '@angular/common';
import { Component, computed, input, model, signal } from '@angular/core';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';

import { SelectMode } from '@app/shared/types/enums/select-mode.enum';
import { Industry } from '@app/shared/types/models/industry/industry.model';
import { UiInputComponent } from '@app/shared/ui/input/ui-input.component';
import { ProffeoUiInputValue } from '@app/shared/ui/types/input.types';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-select-industry-list',
  imports: [TranslatePipe, MatRadioModule, UiInputComponent, NgClass, MatCheckboxModule],
  templateUrl: './select-industry-list.component.html'
})
export class SelectIndustryListComponent {
  private readonly selectedIds = computed(
    (): ReadonlySet<string> => new Set((this.selectedIndustries() ?? []).map(industry => industry.id))
  );

  protected readonly SelectMode = SelectMode;
  protected readonly search = signal<ProffeoUiInputValue>('');
  protected readonly filteredIndustries = computed((): Industry[] => {
    const industries = this.industries() ?? [];
    const searchValue = String(this.search() ?? '').toLowerCase();
    return searchValue ? industries.filter(industry => industry.name.toLowerCase().includes(searchValue)) : industries;
  });
  protected readonly isAllIndustriesSelected = computed((): boolean => {
    return this.industries().length === this.selectedIndustries().length;
  });

  public readonly selectMode = input<SelectMode>(SelectMode.SINGLE);
  public readonly industries = input.required<Industry[]>();
  public readonly selectedIndustries = model<Industry[]>([]);

  protected isSelected(industryId: string): boolean {
    return this.selectedIds().has(industryId);
  }

  protected onIndustryCheckboxChange(event: MatCheckboxChange, industry: Industry): void {
    this.selectIndustry(event.checked, industry);
  }

  protected selectIndustry(isSelected: boolean, industry: Industry): void {
    if (this.selectMode() === SelectMode.SINGLE) {
      this.selectedIndustries.set(isSelected ? [industry] : []);
      return;
    }

    const others = this.selectedIndustries().filter(selected => selected.id !== industry.id);
    this.selectedIndustries.set(isSelected ? [...others, industry] : others);
  }

  protected toggleAllIndustries(event: MatCheckboxChange): void {
    this.selectedIndustries.set(event.checked ? this.industries() : []);
  }
}
